module.exports = __webpack_public_path__ + "static/media/contasiscorp-logo_mobile.6bd6c7e3.webp";